import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, from } from 'rxjs';
import { BaseRentalSummary } from './base-rental-summary.model';
import { BaseRentalType } from './base-rental-type.model';
import { switchMap, concatMap } from '../../../../node_modules/rxjs/operators';
import { BaseRental } from './base-rental.model';
import { toUnspecifiedCentralStartOfDay } from '../../shared/date-utility';

@Injectable({providedIn: 'root'})
export class BaseRentalService {
	private url: string;
	constructor(private httpClient: HttpClient) {
		this.url = 'api/baserental'
	}

	public save(baseRentals: any): Observable<any> {
		return this.httpClient.post<any>(this.url + '/saveAsync', baseRentals);
	}

	public getTypes(): Observable<BaseRentalType[]> {
		return this.httpClient.get<BaseRentalType[]>(this.url + '/getTypes');
	}

	public searchArInvoices(glPostingDate: Date): Observable<any[]> {
		return this.httpClient.get<BaseRentalSummary[]>(this.url + '/searchArInvoices?billingMonth=' +
			glPostingDate.toLocaleDateString(), {responseType: 'json'});
	}

	public searchOwnerArInvoices(glPostingMonth: Date): Observable<BaseRentalSummary[]> {
		return this.httpClient.get<BaseRentalSummary[]>(this.url + '/searchOwnerARInvoices?glPostingMonth=' +
			glPostingMonth.toLocaleDateString(), { responseType: 'json' });
	}

	public getBaseRentalDetails(invoiceId: number,isActiveData:boolean=true ): Observable<any> {
		return this.httpClient.get<any>(this.url + '/getBaseRentalDetails?invoiceId=' + invoiceId+'&isActiveData='+isActiveData);
	}

	public getOpenInvoicesByLeaseRider(rider: string): Observable<any> {
		return this.httpClient.get<any>(this.url + '/getOpenInvoicesByLeaseRider?rider=' + rider);
	}

	public sendBaseRentalAr(invoiceId: number): Observable<number> {
		return this.httpClient.post<number>(this.url + '/sendBaseRentalAr', invoiceId);
	}

	public sendBaseRentalArsSequentially(subject: Subject<number[]>) {
		return subject.pipe(
			switchMap(val => from(val).pipe(
			concatMap(x => this.sendBaseRentalAr(x))
			))
		);
	}

	public getBillingPeriod(): Observable<Date> {
		return this.httpClient.get<Date>(this.url + '/getBillingPeriod');
	}
	public getBaseRentalArInvoicePdf(invoiceId: number, custSfId: string, glPostingDate: Date) : Observable<string> {
		return this.httpClient.get(this.url + '/getArInvoicePdf', //{ responseType: 'text' });
		{
			params: {
				'arInvoiceId': invoiceId.toString(),
				'customerSfId': custSfId,
				'glPostingDate': glPostingDate.toDateString()
			},
			responseType: 'text'
		});
	}
	public fetchBaseRentalInvoices(invoiceIds: any, includePrimaryContacts: boolean): Observable<any> {
		return this.httpClient.post<any> (this.url + '/fetchBaseContactDetails?includePrimaryContacts=' + includePrimaryContacts, invoiceIds);
	}

	public sendInvoices(invoices: any, billingPeriod: Date): Observable<any> {
		return this.httpClient.post(this.url + '/sendInvoices?billingPeriod=' + billingPeriod.toLocaleDateString(), invoices);
	}

	public updateBaseRentalRatesOnApprove(railcarLeaseId: number, notifiedDate:Date): Observable<any> {
		return this.httpClient.post(this.url + '/updateBaseRentalRatesOnApprove?notifiedDate='+notifiedDate.toLocaleDateString(),railcarLeaseId);
	}

	public updateDeletedStatus(ids: number[],isActive:boolean=true ): Observable<any> {
		return this.httpClient.post(this.url + '/updateDeletedStatus?isActive='+isActive,ids); 
	}
	public UpdateBaseRentals(baseRentas: BaseRental[]): Observable<any> {
		const payload = baseRentas.map(br => ({
			...br,
			startDate: br.startDate ? toUnspecifiedCentralStartOfDay(br.startDate) : br.startDate,
			endDate: br.endDate ? toUnspecifiedCentralStartOfDay(br.endDate) : br.endDate
		}));
		return this.httpClient.post(this.url + '/updateBaseRentals', payload);
	}
}
